import React from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { userApi } from '@atheneum/api'

import Action from '@components/Action'
import Edit from '@components/Icon/Edit'
import ACL from '@components/ACL/ACL'

import LoginAs from '@components/LoginAs'

function Actions ({ employee, modalStore, employeeSearchStore, growlStore }) {
  return (
    <div className='actions-wrapper'>
      <ul className='actions'>
        <li className='action'>
          <ACL roles={['Admin', 'Accounting', 'TeamManagment']} inline>
            <Action
              onClick={() => {
                modalStore.show({
                  type: 'EMPLOYEE_FORM',
                  props: {
                    employee: employee
                  }
                })
              }}
            >
              <Edit />
              <span>Edit</span>
            </Action>
          </ACL>
        </li>
        {process.env.REACT_APP_LOGIN_AS_ALLOWED === 'true' && (
          <li className='action'>
            <ACL roles={['Admin']} inline>
              <Action>
                <LoginAs userId={employee.id} />
              </Action>
            </ACL>
          </li>
        )}
        <li className='action'>
          <ACL roles={['Admin', 'HR']} inline>
            <Action
              onClick={() => {
                const actionPromise = employee.status
                  ? userApi.preventPlatformAccess(employee.id)
                  : userApi.enablePlatformAccess(employee.id)

                actionPromise
                  .then(result => {
                    employee.status = result.status
                    employeeSearchStore.search()
                    return growlStore.showSuccess(
                      'Platform access successfully updated'
                    )
                  })
                  .catch(err => {
                    return growlStore.showError(err)
                  })
              }}
            >
              <Edit />
              <span>
                {employee.status ? 'Prevent' : 'Enable'} platform access
              </span>
            </Action>
          </ACL>
        </li>
      </ul>
    </div>
  )
}

Actions.propTypes = {
  employee: PropTypes.object,
  modalStore: PropTypes.object,
  employeeSearchStore: PropTypes.object,
  growlStore: PropTypes.object
}

export default inject(
  'modalStore',
  'employeeSearchStore',
  'growlStore'
)(observer(Actions))
